import React from "react";
import { graphql } from "gatsby";
import { RichText } from "../../utils/richText";
import { motion } from "framer-motion";
import { FADE_UP, useInView } from "../animationUtils";
import ArrowSvg from "../arrowSvg";
import { GatsbyImage } from "gatsby-plugin-image";

export const fragments = graphql`
  fragment Page_SalesCta on PrismicPageDataBodySalesCta {
    primary {
      image {
        alt
        gatsbyImageData(layout: CONSTRAINED, height: 350, width: 350)
      }
      short_description
      quote {
        richText
      }
      button_label
      button_link {
        url
        target
      }
    }
  }
  fragment Project_SalesCta on PrismicProjectDataBodySalesCta {
    primary {
      image {
        alt
        gatsbyImageData(layout: CONSTRAINED, height: 350, width: 350)
      }
      short_description
      quote {
        richText
      }
      button_label
      button_link {
        url
        target
      }
    }
  }
  fragment FocusArea_SalesCta on PrismicFocusAreaDataBodySalesCta {
    primary {
      image {
        alt
        gatsbyImageData(layout: CONSTRAINED, height: 350, width: 350)
      }
      short_description
      quote {
        richText
      }
      button_label
      button_link {
        url
        target
      }
    }
  }
  fragment Homepage_SalesCta on PrismicHomepageDataBodySalesCta {
    primary {
      image {
        alt
        gatsbyImageData(layout: CONSTRAINED, height: 350, width: 350)
      }
      short_description
      quote {
        richText
      }
      button_label
      button_link {
        url
        target
      }
    }
  }



`;

function SalesCta({ data }) {
  const  { image, short_description, quote, button_label, button_link } = data?.primary;
  const [refImage, inViewImage] = useInView();
  return (
    <div className="sales-cta">
      <motion.div
        ref={refImage}
        {...FADE_UP}
        animate={inViewImage ? "start" : ""}
        className="sales-cta__content"
      >
        <GatsbyImage
          image={image?.gatsbyImageData}
          alt={image?.alt}
          className="sales-cta__image"
        />
        {
          quote?.richText &&
          <div className="sales-cta__quote">
            {RichText(quote.richText)}
          </div>
        }

        {
          short_description &&
          <div className="sales-cta__description">
            {short_description}
          </div>
        }
        {
          button_link?.url && button_label &&
          <div className="sales-cta__button">
            <a href={button_link?.url} target={button_link?.target} className="sales-cta__button-link">
              {button_label}
              <ArrowSvg />
            </a>
          </div>
        }
      </motion.div>

    </div>
  );
}

export default SalesCta;
